export default __webpack_public_path__ + "static/media/logo-efarm.a64ea944.webp";